import React, { useEffect } from "react";

export default function StardustBurst({ onClose, score, zodiac, personalizedTag }) {
  useEffect(() => {
    const t = setTimeout(() => onClose?.(), 4500);
    return () => clearTimeout(t);
  }, [onClose]);

  const particles = Array.from({ length: 80 }, (_, i) => {
    const angle = (i / 80) * Math.PI * 2 + Math.random() * 0.5;
    const dist = 200 + Math.random() * 400;
    return {
      id: `p-${i}`,
      dx: `${Math.cos(angle) * dist}px`,
      dy: `${Math.sin(angle) * dist}px`,
      delay: `${Math.random() * 0.6}s`,
      size: 4 + Math.random() * 8,
    };
  });

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center" data-testid="stardust-burst-overlay" onClick={onClose}>
      <div className="absolute inset-0 bg-[#15111A]/85 backdrop-blur-sm" />
      <div className="relative w-full h-full flex items-center justify-center">
        <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-0 h-0">
          {particles.map((p) => (
            <span
              key={p.id}
              className="stardust-particle"
              style={{
                width: `${p.size}px`,
                height: `${p.size}px`,
                animationDelay: p.delay,
                "--dx": p.dx,
                "--dy": p.dy,
              }}
            />
          ))}
        </div>

        <div className="relative text-center px-6 max-w-2xl">
          <div className="font-mono-scanner text-8xl text-[#C8A96E]" style={{ textShadow: "0 0 40px rgba(200,169,110,0.8)" }} data-testid="stardust-score">
            {score}
          </div>
          <h2 className="mt-4 font-heading text-3xl sm:text-4xl text-white tracking-tighter">
            ✨ Perfect Numeric Synchronization!
          </h2>
          <p className="mt-4 text-[#A89C98] text-lg">
            Your <span className="text-[#C8A96E]">{personalizedTag || `${zodiac || "Pisces"}-Dragon`}</span> energy is perfectly aligned with this coordinate framework.
          </p>
          <button
            data-testid="stardust-close-btn"
            onClick={onClose}
            className="mt-8 text-xs uppercase tracking-[0.3em] text-[#C8A96E] hover:text-white transition-colors"
          >
            Continue journey →
          </button>
        </div>
      </div>
    </div>
  );
}
